export function isActiveOrder(order) {
  return order.shipping
    ? ['Awaiting Fulfillment', 'Shipped'].indexOf(order.shipping_status) !== -1
    : [0, 1, 2, 7].indexOf(order.order_status) !== -1;
}

export function isCompletedOrder(order) {
  return order.shipping
    ? order.shipping_status === 'Completed'
    : order.order_status === 3;
}

export function isFailedOrder(order) {
  return order.shipping
    ? order.shipping_status === 'Failed'
    : order.order_status === 4;
}

export function isCanceledOrder(order) {
  return order.shipping
    ? order.shipping_status === 'Cancelled'
    : order.order_status === 5;
}

export function isRejectedOrder(order) {
  return order.order_status === -1;
}

export function isTotalLineItem({ title }) {
  return (title || '').toLowerCase() === 'total';
}



// WEBPACK FOOTER //
// ./shared/models/order.js